// import React from 'react'
// import { Link } from 'react-router-dom'
// import Services from '../../api/service'
// import SectionTitle from '../SectionTitle'




// const ServiceSection = (props) => {
//     const ClickHandler = () => {
//         window.scrollTo(10, 0);
//     }


//     return (
//         <div className={`wpo-service-area section-padding ${props.sClass}`}>
//             <div className="container">
//                 <SectionTitle subTitle={'Our Capabilities'} MainTitle={'What We Do'}/>
//                 <div className="row align-items-center">
//                     {Services.slice(0,6).map((service, sitem) => (
//                         <div className="col-lg-4 col-md-6 col-12" key={sitem}>
//                             <div className="wpo-service-item">
//                                 <i className={service.icon}></i>
//                                 <h2>{service.sTitle}</h2>
//                                 <p>{service.description}</p>
//                                 <Link onClick={ClickHandler} to={`/service-single/${service.Id}`}>Learn More...</Link>
//                             </div>
//                         </div>
//                     ))}

//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ServiceSection;
















import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../SectionTitle';
import { getCapabilities } from '../../api/Above';

const ServiceSection = ({ sClass }) => {
  const [capabilities, setCapabilities] = useState(null);

  useEffect(() => {
    const fetchCapabilities = async () => {
      try {
        const data = await getCapabilities();
        setCapabilities(data);
      } catch (error) {
        console.error("Failed to fetch capabilities:", error);
      }
    };
    fetchCapabilities();
  }, []);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  if (!capabilities) return null; // or a loader

  return (
    <div className={`wpo-service-area section-padding ${sClass}`}>
      <div className="container">
        <SectionTitle
          subTitle={capabilities.subtitle}
          MainTitle={capabilities.MainTitle}
        />
        <div className="row align-items-center">
          {capabilities.ourcapabities.slice(0, 6).map((service, idx) => (
            <div className="col-lg-4 col-md-6 col-12" key={idx}>
              <div className="wpo-service-item">
                {/* Optional: if you want icons dynamically, you can add icon field in backend */}
                {service.icon && <i className={service.icon}></i>}
                <h2>{service.cardTitle}</h2>
                <p>{service.description}</p>
                <Link onClick={ClickHandler} to={service.button_link}>
                  {service.button_text}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
